import { Component } from '@angular/core';

/**
 * This component projects content into the header section of the basic layout.
 * It mostly contains navigation elements or branding information like logo, title, etc.
 *
 * Please use this component only within the `lvr-basic-layout` component.
 *
 * Example usage:
 * ```html
 * <lvr-basic-layout>
 *   <lvr-basic-layout-header> Header Content </lvr-basic-layout-header>
 *   <lvr-basic-layout-left> Left Side Content </lvr-basic-layout-left>
 *   <p>Main Content</p>
 * </lvr-basic-layout>
 * ```
 */
@Component({
	selector: 'lvr-basic-layout-header',
	template: `<ng-content></ng-content>`,
	styles: [
		`
			:host {
				width: 100%;
				display: grid;
				grid-template-columns: 1fr 1fr 1fr;
				grid-template-rows: 1fr;
			}
		`,
	],
})
export class BasicLayoutHeaderComponent {}
